import { TRACKERS } from "@/constants/Trackers";
import { SexualHistory } from "@/features/Patient/MedicalRecords/SexualHistory/SexualHistory";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/sexual-history")({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_SEXUAL_HISTORY);
  },
});

function RouteComponent() {
  return <SexualHistory />;
}
